(function() {
  var dd = null;
  var triggerEl = null;

  function build() {
    // Find "Svi proizvodi" link - the one with aria-haspopup (has submenu)
    var link = document.querySelector('.menu-list__link[aria-haspopup="true"]');
    if (!link) return;
    triggerEl = link;

    // Read items from theme's hidden submenu
    var submenu = triggerEl.closest('.menu-list__list-item').querySelector('.menu-list__submenu');
    var items = [];
    if (submenu) {
      var megaLinks = submenu.querySelectorAll('a');
      megaLinks.forEach(function(ml) {
        var text = ml.textContent.trim();
        var href = ml.getAttribute('href');
        // Skip parent duplicate (same href as trigger)
        if (href === triggerEl.getAttribute('href')) return;
        if (text && href) items.push({text: text, href: href});
      });
    }

    dd = document.createElement('div');
    dd.id = 'ortophex-custom-dd';
    items.forEach(function(item) {
      var a = document.createElement('a');
      a.href = item.href;
      a.textContent = item.text;
      dd.appendChild(a);
    });
    document.body.appendChild(dd);
  }

  function show() {
    if (!dd || !triggerEl) return;
    var r = triggerEl.getBoundingClientRect();
    dd.style.top = r.bottom + 'px';
    dd.style.left = (r.left + r.width/2) + 'px';
    dd.style.display = 'block';
  }

  function hide() { if (dd) dd.style.display = 'none'; }

  function init() {
    build();
    if (!dd || !triggerEl) return;

    // Click on trigger toggles
    document.addEventListener('click', function(e) {
      var onDd = e.target.closest('#ortophex-custom-dd');
      var clickedLink = e.target.closest('a.menu-list__link');
      var onTrigger = (clickedLink === triggerEl);

      if (onTrigger) {
        e.preventDefault();
        e.stopPropagation();
        if (dd.style.display === 'block') hide(); else show();
        return;
      }

      if (onDd) return; // clicking dropdown link - let it navigate

      hide(); // click outside
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 500); });
  } else {
    setTimeout(init, 500);
  }
})();
